import { useEffect, useState } from 'preact/hooks';
import { fetchPromoMessageMap, getCachedPromoMessageMap, } from '../utils/fetchPromoMessageMap';
const EMPTY_MAP = new Map();
/**
 * Hook providing the `plp_promo_message` map keyed by lowercase handle plus a
 * `loaded` flag. Consumers use `loaded` to reserve layout for a promo label
 * while the Storefront fetch is in flight (CLS prevention).
 *
 * Triggers the fetch on first mount across the app; re-renders subscribers
 * when the map resolves. Subsequent callers read the module-level cache.
 */
export function usePromoMessageMap() {
    const [state, setState] = useState(() => {
        const cached = getCachedPromoMessageMap();
        return { map: cached !== null && cached !== void 0 ? cached : EMPTY_MAP, loaded: cached !== null };
    });
    useEffect(() => {
        if (state.loaded)
            return;
        let cancelled = false;
        fetchPromoMessageMap().then(next => {
            if (!cancelled)
                setState({ map: next, loaded: true });
        });
        return () => {
            cancelled = true;
        };
    }, [state.loaded]);
    return state;
}
